module.exports = __webpack_public_path__ + "img/luna menguante.3d049dd6.png";